import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Checkbox,
  Flex,
  Spinner,
  Text,
} from "@chakra-ui/react";
import axios from "axios";
import apiUrl from "variables/api";
import { toast } from "react-toastify";

export default function AttendanceModal({
  isOpen,
  onClose,
  training,
  platoon,
  companyID,
  index,
  peoples,
  fetchScheduleData,
}) {
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      axios
        .get(
          apiUrl +
            `/data/school/company/attendance/${companyID}/${index}/${platoon}`,
          {
            headers: { "x-access-token": localStorage.getItem("token") },
          }
        )
        .then((response) => {
          if (response.data.attendance) {
            const fetchedAttendance = response.data.attendance || [];
            axios
              .get(apiUrl + `/data/school/company/users/list`, {
                headers: { "x-access-token": localStorage.getItem("token") },
              })
              .then((userResponse) => {
                const allUsers = userResponse.data.filter(
                  (user) => user.platoon === platoon
                );
                const updatedAttendance = allUsers.map((user) => {
                  let existingUser = fetchedAttendance.find(
                    (att) => att.dbid === user.id
                  );
                  if(existingUser) {
                  existingUser.number = user.number;
                  existingUser.archived = user.archived;
                  }
                  return (
                    existingUser || {
                      number: user.number,
                      dbid: user.id,
                      archived: user.archived,
                      nick:
                        peoples.find((people) => people.value == user.userID)
                          ?.label || "Nieznany użytkownik",
                      OB: false,
                      NB: false,
                      U: false,
                    }
                  );
                });
                setAttendanceData(updatedAttendance);
                setLoading(false);
              })
              .catch((error) => {
                console.log("blad", error)
                console.error(error);
                toast.error(
                  "Napotkano błąd podczas pobierania listy użytkowników 3"
                );
                setLoading(false);
              });
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            axios
              .get(apiUrl + `/data/school/company/users/list`, {
                headers: { "x-access-token": localStorage.getItem("token") },
              })
              .then((userResponse) => {
                const allUsers = userResponse.data.filter(
                  (user) => user.platoon === platoon
                );
                const updatedAttendance = allUsers.map((user) => ({
                  number: user.number,
                  dbid: user.id,
                  archived: user.archived,
                  nick:
                    peoples.find((people) => people.value == user.userID)
                      ?.label || "Nieznany użytkownik",
                  OB: false,
                  NB: false,
                  U: false,
                }));
                setAttendanceData(updatedAttendance);
                setLoading(false);
              })
              .catch((userError) => {
                console.error(userError);
                toast.error(
                  "Napotkano błąd podczas pobierania listy użytkowników 1"
                );
                setLoading(false);
              });
          } else {
            console.error(error);
            toast.error("Napotkano błąd podczas pobierania danych frekwencji 4");
            setLoading(false);
          }
        });
    }
  }, [isOpen, index, platoon, peoples]);

  const handleSave = () => {

    const filteredAttendanceData = attendanceData.filter((user) => !user.archived);

    axios
      .post(
        apiUrl + "/data/school/company/attendance/save",
        {
          eventID: index,
          companyID: companyID,
          platoon: platoon,
          data: filteredAttendanceData,
        },
        {
          headers: { "x-access-token": localStorage.getItem("token") },
        }
      )
      .then((response) => {
        toast.success("Pomyślnie zapisano frekwencję");
        fetchScheduleData();
        onClose();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas zapisywania frekwencji 2");
      });
  };

  const handleCheckboxChange = (index, field) => {
    const newData = [...attendanceData];
    newData[index].OB = false;
    newData[index].NB = false;
    newData[index].U = false;
    newData[index][field] = !newData[index][field];
    setAttendanceData(newData);
  };

  const handleCopyToClipboard = () => {
    const attendanceText = attendanceData
      .map((user) => {
        if (user.OB) return "1";
        if (user.NB) return "0";
        if (user.U) return "u";
        return "-";
      })
      .join("\n");

    navigator.clipboard.writeText(attendanceText).then(
      () => {
        toast.success("Frekwencja została skopiowana do schowka");
      },
      (err) => {
        console.error("Błąd podczas kopiowania do schowka: ", err);
        toast.error("Błąd podczas kopiowania do schowka");
      }
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Sprawdzanie frekwencji</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {loading ? (
            <Flex justifyContent="center" alignItems="center" height="100%">
              <Spinner size="xl" />
            </Flex>
          ) : (
            <Table size="sm" variant="simple">
              <Thead>
                <Tr>
                  <Th>Nr.</Th>
                  <Th>Nick</Th>
                  <Th>OB</Th>
                  <Th>NB</Th>
                  <Th>U</Th>
                </Tr>
              </Thead>
              <Tbody>
                {attendanceData
                  .sort((a, b) => a.number - b.number)
                  .map((person, index) => {
                    return (
                      <Tr key={index}>
                        <Td>{person.number}</Td>
                        <Td><Text as={person.archived ? "s" : undefined}>{person.nick}</Text></Td>
                        <Td>
                          <Checkbox
                            isChecked={person.OB}
                            onChange={() => handleCheckboxChange(index, "OB")}
                            disabled={person.archived}
                          />
                        </Td>
                        <Td>
                          <Checkbox
                            isChecked={person.NB}
                            onChange={() => handleCheckboxChange(index, "NB")}
                            disabled={person.archived}
                          />
                        </Td>
                        <Td>
                          <Checkbox
                            isChecked={person.U}
                            onChange={() => handleCheckboxChange(index, "U")}
                            disabled={person.archived}
                          />
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          )}
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="purple" mr={3} onClick={handleCopyToClipboard}>
            Skopiuj do schowka
          </Button>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Anuluj
          </Button>
          <Button colorScheme="green" onClick={handleSave}>
            Zapisz
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
